import { EmailQuoteFormValues } from '../interfaces/mail.interface'
import { functions } from '../utils/flamelink'

export const sendEmail = async (data: EmailQuoteFormValues) => {
  return functions().httpsCallable('sendMail')(data)
}
